
<script>
	//

export let thumbData
//
let theTitle;
let baseURL ="https://strapi.understory.community";
// console.log("thumbData: ", thumbData);
let theImg = thumbData.Image[0];
let imgURL = baseURL + theImg.formats.small.url// ""+ JSON.stringify(theImg.formats.small.url);
let alt = theImg.alternativeText;
//
let theMapLink = thumbData.ButtonLink;


</script>
{#if thumbData}
<article>
<a href="{theMapLink}" title="{thumbData.Title}" role="link">
    <img src="{imgURL}" alt="{alt}" />
</a>
 <h3>{thumbData.Title}</h3>
 	{#if thumbData.Copy}
		<p>{@html thumbData.Copy}</p>
	{/if}
</article>
{/if}